import { toast } from "react-toastify";
import { getAPI } from "services/CRUDServices";
import { errorAudio, postAudio, repeatAudio, successAudio } from "tools/functions/Methods";

export type ScanMode = "immediate" | "list";

export interface GlobalScanOptions {
  mode: ScanMode;
  existingIds?: string[];
  onApiSuccess?: (response: any) => void;
  apiFunction?: (url: string, method: string, data: any) => Promise<any>;
  apiUrl?: string;
  apiPayload?: Record<string, any>;
  onLocalSuccess?: (items: { serialNumber: string }[]) => void;
  setLoading?: (loading: boolean) => void;
}

const SINGLE_BARCODE_LENGTHS = [13, 24, 25];

export async function handleGlobalScan(
  barcode: string,
  options: GlobalScanOptions
): Promise<void> {
  const {
    mode,
    existingIds = [],
    onLocalSuccess,
    onApiSuccess,
    apiFunction,
    apiUrl,
    apiPayload = {},
    setLoading,
  } = options;

  const isSingle = SINGLE_BARCODE_LENGTHS.includes(barcode.length);

  try {
    setLoading?.(true);

    if (isSingle) {
      if (existingIds.includes(barcode)) {
        toast.error("مرسوله تکراری است");
        repeatAudio();
        return;
      }

      if (mode === "immediate") {
        if (!apiFunction || !apiUrl) return;

        const res = await apiFunction(apiUrl, "post", {
          ...apiPayload,
          number: barcode,
        });

        onApiSuccess?.(res.data.response);
        playAudio(res)

        return;
      }

      onLocalSuccess?.([{ serialNumber: barcode }]);
      successAudio();
      
      return;
    }

    const response = await getAPI(
      `/consignment-api/delivery/bag/${barcode}/consignments-info`
    );

    const bagItems =
      response.data.payload?.map((item: any) => ({
        serialNumber: item.cprNumber.toString(),
      })) || [];

    if (!bagItems.length) {
      toast.warning("کیسه اسکن شده خالی است.");
      return;
    }

    const newItems = bagItems.filter(
      (item) => !existingIds.includes(item.serialNumber)
    );

    if (!newItems.length) {
      toast.error("تمام مرسوله‌های کیسه تکراری بودند");
      repeatAudio();
   
      return;
    }

    onLocalSuccess?.(newItems);
    successAudio();
      

  } catch {
    toast.error("خطا در اسکن");
    errorAudio();
  } finally {
    setLoading?.(false);
  }
}




export interface ConfirmOptions {
  apiFunction: (url: string, method: string, data: any) => Promise<any>;
  apiUrl: string;
  apiPayload?: Record<string, any>;
  existingIds?: string[];
  onApiSuccess?: (response: any) => void;
  onAllDone?: () => void;
  setLoading?: (isLoading: boolean) => void;
}

export async function confirmBarcodeListWithAPI(
  barcodes: { serialNumber: string }[],
  options: ConfirmOptions
): Promise<void> {
  const {
    apiFunction,
    apiUrl,
    apiPayload = {},
    existingIds = [],
    onApiSuccess,
    onAllDone,
    setLoading,
  } = options;

  if (setLoading) setLoading(true);

  try {
    for (const item of barcodes) {
      if (existingIds.includes(item.serialNumber)) continue;

      try {
        const res = await apiFunction(apiUrl, "post", {
          ...apiPayload,
          number: item.serialNumber,
        });
        if (typeof onApiSuccess === "function") {
          onApiSuccess(res.data.response);
        }
         playAudio(res)
        
      } catch {
        errorAudio();

      }

      if (barcodes.length > 1) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    }
  } finally {
    if (setLoading) setLoading(false);
    if (typeof onAllDone === "function") onAllDone();
  }
}


const playAudio=(res)=>{
  const isOkShift=res.data.response?.isOkShift
  const isPost=res.data.response?.isPost
    if(isOkShift){
        // shiftAudio()
        return
    }
    if (isPost) {

        postAudio();
        return
    } 

    successAudio();
}